var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(`Погрузка: ${ _vm.addressMap.get(_vm.item.loading).shortName }, зоны до ${_vm.distances} км.`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }